import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { ServiceTileLayout } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import { TextInfo } from "../Tabs/components/TextInfo";
import { ServiceTile } from "./ServiceTile";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var LayoutServices = /*#__PURE__*/memo(function (_ref) {
  var headerBarConfig = _ref.headerBarConfig,
    layoutType = _ref.layoutType,
    size = _ref.size,
    services = _ref.services,
    _ref$blockIndex = _ref.blockIndex,
    blockIndex = _ref$blockIndex === void 0 ? 0 : _ref$blockIndex;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInfo, {
    className: cn('title'),
    headerText: headerBarConfig === null || headerBarConfig === void 0 ? void 0 : headerBarConfig.headerText,
    subtitleText: headerBarConfig === null || headerBarConfig === void 0 ? void 0 : headerBarConfig.subtitleText,
    "data-t-id": "components-LayoutServices"
  }), /*#__PURE__*/React.createElement(ServiceTileLayout, {
    size: size,
    type: layoutType
  }, services.map(function (service, i) {
    return /*#__PURE__*/React.createElement(ServiceTile, _extends({}, service, {
      blockIndex: blockIndex,
      key: i
    }));
  })));
});